// Central bilingual content + brand/data assets

export const ASSETS = {
  companyLogo:
    "https://customer-assets-agu9un31.emergentagent.net/job_4cb23e94-9099-41ea-90d5-bc25fb08d656/artifacts/gz4wewgq_file%20%282%29.jpg",
  darZaid:
    "https://customer-assets-agu9un31.emergentagent.net/job_4cb23e94-9099-41ea-90d5-bc25fb08d656/artifacts/psfcdhil_New%20Project%20%282%29.jpg",
  coz:
    "https://customer-assets-agu9un31.emergentagent.net/job_4cb23e94-9099-41ea-90d5-bc25fb08d656/artifacts/p1bj5nrg_New%20Project%20%281%29.jpg",
  goa:
    "https://customer-assets-agu9un31.emergentagent.net/job_4cb23e94-9099-41ea-90d5-bc25fb08d656/artifacts/imzbdv1n_GOA%20Logo.webp",
  zed:
    "https://customer-assets-agu9un31.emergentagent.net/job_4cb23e94-9099-41ea-90d5-bc25fb08d656/artifacts/nzj34nzq_ZED%20Logo.webp",
  zedMeals:
    "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/2ou0mjl8_ZED%20Meals%20Logo.webp",
  sahab:
    "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/drk0q310_WhatsApp%20Image%202026-07-13%20at%2010.59.44%20AM.jpeg",
  heroBg:
    "https://images.unsplash.com/photo-1753727471014-efe38840c7c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYWZlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg1NDAwMDAyfDA&ixlib=rb-4.1.0&q=85",
  darZaidImg:
    "https://images.unsplash.com/photo-1689672235501-6dc1e56d454c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBmaW5lJTIwZGluaW5nJTIwcGxhdGV8ZW58MHx8fHwxNzg1NDAwMDAyfDA&ixlib=rb-4.1.0&q=85",
  cozImg:
    "https://images.unsplash.com/photo-1623000850293-0cbbc517c719?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxnb3VybWV0JTIwY2hvY29sYXRlfGVufDB8fHx8MTc4NTQwMDAwN3ww&ixlib=rb-4.1.0&q=85",
  goaImg:
    "https://images.unsplash.com/photo-1675328657878-194029e7ccbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBmaW5lJTIwZGluaW5nJTIwcGxhdGV8ZW58MHx8fHwxNzg1NDAwMDAyfDA&ixlib=rb-4.1.0&q=85",
  zedImg:
    "https://images.unsplash.com/photo-1729809106394-7ceb922b37f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYWZlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg1NDAwMDAyfDA&ixlib=rb-4.1.0&q=85",
  sahabImg:
    "https://images.unsplash.com/photo-1651993841930-946a700c1524?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxnb3VybWV0JTIwYnVyZ2VyJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc4NTQwMDAwMXww&ixlib=rb-4.1.0&q=85",
  factoryImg:
    "https://images.unsplash.com/photo-1716643863806-989dd76ae093?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwY29tbWVyY2lhbCUyMGJha2VyeSUyMGZhY3Rvcnl8ZW58MHx8fHwxNzg1NDAwMDAyfDA&ixlib=rb-4.1.0&q=85",
};

export const CONTENT = {
  ar: {
    dir: "rtl",
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      brands: "علاماتنا",
      b2b: "الجملة والمصنع",
      quality: "الجودة",
      clients: "عملاؤنا",
      careers: "التوظيف",
      contact: "تواصل معنا",
    },
    company: {
      name: "شركة الإزدهار والرفاه للتجارة المحدودة",
      short: "الإزدهار والرفاه",
    },
    hero: {
      kicker: "منذ ٢٠١٠ · جدة، المملكة العربية السعودية",
      title: ["شركة الإزدهار", "والرفاه للتجارة", "المحدودة"],
      tagline: "بصمتنا في عالم الأطعمة",
      overview:
        "مجموعة سعودية رائدة في قطاع الأغذية والمشروبات، تجمع بين الضيافة الأصيلة والابتكار الحديث عبر محفظة من العلامات التجارية المميزة ومصنع مركزي متكامل.",
      cta1: "علاماتنا التجارية",
      cta2: "الجملة B2B",
      cta3: "انضم إلينا",
      scroll: "اكتشف المزيد",
    },
    about: {
      kicker: "قصتنا",
      title: "من مختبر جيلاتو صغير إلى مجموعة أطعمة متكاملة",
      chapters: [
        {
          year: "٢٠١٠",
          title: "البداية",
          text: "انطلقت الرحلة من مختبر جيلاتو صغير بشغفٍ صادق نحو الجودة والنكهة الأصيلة، لتضع أولى بصماتنا في عالم الأطعمة.",
        },
        {
          year: "٢٠١٦",
          title: "تأسيس الشركة",
          text: "تأسست شركة الإزدهار والرفاه للتجارة المحدودة رسمياً، لتوسيع الرؤية وبناء محفظة من العلامات التجارية المتنوعة.",
        },
        {
          year: "اليوم",
          title: "مصنع مركزي حديث",
          text: "نمتلك اليوم مصنعاً مركزياً حديثاً بمساحة 5,600 م² يغذّي منافذنا وشركاءنا بأعلى معايير الجودة والسلامة الغذائية.",
        },
      ],
      visionTitle: "رؤيتنا",
      vision:
        "أن نكون المجموعة الرائدة في قطاع الأغذية والمشروبات في المملكة، نصنع تجارب استثنائية تُلهم وتُبهج.",
      missionTitle: "مهمتنا",
      mission:
        "تقديم منتجات وخدمات غذائية عالية الجودة عبر علامات تجارية ملهمة ومصنع مركزي متكامل، مع الالتزام بأعلى معايير السلامة والاستدامة.",
    },
    stats: {
      kicker: "أرقام تتحدث عنّا",
      items: [
        { value: 63, suffix: "+", label: "منفذ نشط" },
        { value: 5600, suffix: " م²", label: "مصنع مركزي" },
        { value: 22, suffix: "+", label: "ماكينة بيع ذاتي" },
        { value: 60, suffix: "+", label: "موقع ZED" },
        { value: 1000, suffix: "+", label: "مشترك شهرياً" },
      ],
    },
    brands: {
      kicker: "علامتنا",
      title: "علاماتنا التجارية",
      subtitle: "ست علامات، بصمة واحدة من التميّز.",
      newLabel: "جديد",
      closedLabel: "مغلق مؤقتاً",
      comingSoonLabel: "قريباً",
      visit: "تفاصيل العلامة",
    },
    b2b: {
      kicker: "الجملة والمصنع",
      title: "شريكك في الإمداد الغذائي",
      text: "نوفّر حلول إمداد بالجملة للمقاهي والمطاعم وشركات الضيافة، انطلاقاً من مصنعنا المركزي بمعايير جودة عالمية.",
      items: [
        { title: "مخبوزات مجمّدة", text: "كرواسون ومعجنات جاهزة للخبز بجودة حرفية." },
        { title: "وجبات جاهزة", text: "حلول وجبات مبتكرة وجاهزة للتقديم." },
        { title: "حلويات", text: "كيك وحلويات فاخرة للمناسبات والمنافذ." },
        { title: "آيس كريم وجيلاتو", text: "خبرتنا الأصيلة منذ ٢٠١٠." },
      ],
      cta: "اطلب عرض أسعار",
    },
    quality: {
      kicker: "الجودة والاعتمادات",
      title: "معايير عالمية موثّقة",
      text: "منشآتنا معتمدة من TÜV AUSTRIA وفق أرقى المعايير الدولية للجودة وسلامة الغذاء.",
      viewCert: "عرض الشهادة",
      certs: [
        { code: "ISO 9001:2015", label: "إدارة الجودة" },
        { code: "ISO 22000:2018", label: "سلامة الغذاء" },
        { code: "HACCP:2003", label: "تحليل المخاطر" },
      ],
    },
    clients: {
      kicker: "شركاء النجاح",
      title: "يثقون بنا",
    },
    careers: {
      kicker: "انضم إلى فريقنا",
      title: "ابنِ مستقبلك معنا",
      text: "نبحث دائماً عن المواهب الشغوفة التي تشاركنا الرؤية. اكتشف ثقافتنا وقدّم طلبك اليوم.",
      cultureTitle: "لماذا الإزدهار والرفاه؟",
      culture: [
        "بيئة عمل ملهمة تحتفي بالإبداع.",
        "فرص نمو حقيقية عبر علامات متعددة.",
        "معايير جودة وسلامة عالمية.",
        "فريق شغوف بالضيافة والتميّز.",
      ],
      formTitle: "قدّم طلبك",
      fields: {
        fullName: "الاسم الكامل",
        email: "البريد الإلكتروني",
        phone: "رقم التواصل",
        position: "المسمى الوظيفي المطلوب",
        experience: "سنوات الخبرة",
        resume: "السيرة الذاتية (PDF / Word، بحد أقصى ٥ ميجابايت)",
        cover: "رسالة تعريفية مختصرة",
        submit: "إرسال الطلب",
        uploadHint: "اسحب الملف هنا أو اضغط للاختيار",
      },
      success: "تم استلام طلبك بنجاح! سنتواصل معك قريباً.",
      error: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    },
    contact: {
      kicker: "تواصل معنا",
      title: "لنتحدّث",
      text: "هل لديك استفسار أو فرصة شراكة؟ فريقنا في خدمتك.",
      fields: {
        name: "الاسم",
        email: "البريد الإلكتروني",
        phone: "رقم الجوال",
        inquiry: "نوع الاستفسار",
        message: "رسالتك",
        submit: "إرسال الرسالة",
      },
      inquiryTypes: [
        { value: "general", label: "استفسار عام" },
        { value: "b2b", label: "الإمداد بالجملة B2B" },
        { value: "franchise", label: "امتياز / شراكة" },
      ],
      success: "تم إرسال رسالتك بنجاح! شكراً لتواصلك.",
      error: "حدث خطأ. يرجى المحاولة مرة أخرى.",
      infoTitle: "معلومات التواصل",
      addressLabel: "العنوان",
      address: "مبنى رقم ٨٧٤٠، الرمز البريدي ٢٢٤٢٣، جدة، المملكة العربية السعودية.",
    },
    footer: {
      tagline: "بصمتنا في عالم الأطعمة",
      quickLinks: "روابط سريعة",
      contact: "تواصل",
      rights: "جميع الحقوق محفوظة",
      cta: "لنصنع شيئاً مميزاً",
    },
  },

  en: {
    dir: "ltr",
    nav: {
      home: "Home",
      about: "About Us",
      brands: "Brands",
      b2b: "B2B & Factory",
      quality: "Quality",
      clients: "Clients",
      careers: "Careers",
      contact: "Contact Us",
    },
    company: {
      name: "Al-Ezdhar & Al-Rafah Trading Ltd.",
      short: "Al-Ezdhar & Al-Rafah",
    },
    hero: {
      kicker: "SINCE 2010 · JEDDAH, SAUDI ARABIA",
      title: ["Al-Ezdhar &", "Al-Rafah Trading", "Ltd."],
      tagline: "Making Our Mark in F&B",
      overview:
        "A leading Saudi food & beverage group blending authentic hospitality with modern innovation across a portfolio of distinctive brands, powered by an integrated central factory.",
      cta1: "Our Brands",
      cta2: "B2B Wholesale",
      cta3: "Careers",
      scroll: "Discover More",
    },
    about: {
      kicker: "OUR STORY",
      title: "From a small gelato lab to an integrated food group",
      chapters: [
        {
          year: "2010",
          title: "The Beginning",
          text: "Our journey began in a small gelato lab, driven by a genuine passion for quality and authentic flavour — our very first mark in the world of food.",
        },
        {
          year: "2016",
          title: "Company Founded",
          text: "Al-Ezdhar & Al-Rafah Trading Ltd. was formally established, expanding the vision and building a portfolio of diverse brands.",
        },
        {
          year: "TODAY",
          title: "Modern Central Factory",
          text: "Today we operate a modern 5,600 m² central factory that supplies our outlets and partners with the highest standards of quality and food safety.",
        },
      ],
      visionTitle: "Our Vision",
      vision:
        "To be the leading food & beverage group in the Kingdom, crafting exceptional experiences that inspire and delight.",
      missionTitle: "Our Mission",
      mission:
        "To deliver high-quality food products and services through inspiring brands and an integrated central factory, committed to the highest standards of safety and sustainability.",
    },
    stats: {
      kicker: "THE NUMBERS",
      items: [
        { value: 63, suffix: "+", label: "Active Outlets" },
        { value: 5600, suffix: " m²", label: "Central Factory" },
        { value: 22, suffix: "+", label: "Vending Machines" },
        { value: 60, suffix: "+", label: "ZED Locations" },
        { value: 1000, suffix: "+", label: "Monthly Subscribers" },
      ],
    },
    brands: {
      kicker: "OUR PORTFOLIO",
      title: "Our Brands",
      subtitle: "Six brands, one signature of excellence.",
      newLabel: "NEW",
      closedLabel: "Temporarily Closed",
      comingSoonLabel: "Coming Soon",
      visit: "Explore Brand",
    },
    b2b: {
      kicker: "B2B & FACTORY",
      title: "Your partner in food supply",
      text: "We provide wholesale supply solutions for cafes, restaurants and catering companies, powered by our central factory with world-class quality standards.",
      items: [
        { title: "Frozen Bakery", text: "Croissants & ready-to-bake pastries with artisan quality." },
        { title: "Ready Meals", text: "Innovative, ready-to-serve meal solutions." },
        { title: "Desserts", text: "Premium cakes & desserts for events and outlets." },
        { title: "Ice Cream & Gelato", text: "Our authentic expertise since 2010." },
      ],
      cta: "Request a Quote",
    },
    quality: {
      kicker: "QUALITY & CERTIFICATES",
      title: "Certified global standards",
      text: "Our facilities are certified by TÜV AUSTRIA to the highest international standards for quality and food safety.",
      viewCert: "View Certificate",
      certs: [
        { code: "ISO 9001:2015", label: "Quality Management" },
        { code: "ISO 22000:2018", label: "Food Safety" },
        { code: "HACCP:2003", label: "Hazard Analysis" },
      ],
    },
    clients: {
      kicker: "TRUSTED PARTNERS",
      title: "They trust us",
    },
    careers: {
      kicker: "JOIN OUR TEAM",
      title: "Build your future with us",
      text: "We are always looking for passionate talent who share our vision. Discover our culture and apply today.",
      cultureTitle: "Why Al-Ezdhar & Al-Rafah?",
      culture: [
        "An inspiring workplace that celebrates creativity.",
        "Real growth opportunities across multiple brands.",
        "World-class quality and safety standards.",
        "A team passionate about hospitality and excellence.",
      ],
      formTitle: "Submit your application",
      fields: {
        fullName: "Full Name",
        email: "Email",
        phone: "Phone Number",
        position: "Position Applied For",
        experience: "Years of Experience",
        resume: "Resume / CV (PDF / Word, max 5MB)",
        cover: "Short Cover Note",
        submit: "Submit Application",
        uploadHint: "Drag file here or click to select",
      },
      success: "Your application has been received! We'll be in touch soon.",
      error: "Something went wrong. Please try again.",
    },
    contact: {
      kicker: "CONTACT US",
      title: "Let's talk",
      text: "Have an inquiry or a partnership opportunity? Our team is here for you.",
      fields: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        inquiry: "Inquiry Type",
        message: "Your Message",
        submit: "Send Message",
      },
      inquiryTypes: [
        { value: "general", label: "General Inquiry" },
        { value: "b2b", label: "B2B Supply" },
        { value: "franchise", label: "Franchise / Partnership" },
      ],
      success: "Your message has been sent! Thank you for reaching out.",
      error: "Something went wrong. Please try again.",
      infoTitle: "Contact Information",
      addressLabel: "Address",
      address: "Building No 8740, Postal Code 22423, Jeddah, Saudi Arabia.",
    },
    footer: {
      tagline: "Making Our Mark in F&B",
      quickLinks: "Quick Links",
      contact: "Contact",
      rights: "All rights reserved",
      cta: "Let's make something remarkable",
    },
  },
};

export const BRANDS = [
  {
    key: "dar_zaid",
    slug: "dar-zaid",
    status: "closed",
    social: {
      instagram: "https://www.instagram.com/maisondezaid/",
      tiktok: "https://www.tiktok.com/@darzaid.ksa",
    },
    logo: ASSETS.darZaid,
    image: ASSETS.darZaidImg,
    bg: "#0B2434",
    accent: "#C4A27A",
    name: { ar: "دار زيد", en: "Dar Zaid" },
    tag: { ar: "الضيافة والمطاعم", en: "Dining & Hospitality" },
    subtitle: { ar: "مطعم وضيافة", en: "Restaurant & Hospitality" },
    desc: {
      ar: "تجربة طعام عصرية وضيافة عائلية أصيلة في أجواء راقية.",
      en: "Modern dining and authentic family hospitality in refined settings.",
    },
  },
  {
    key: "coz",
    slug: "coz",
    status: "active",
    social: {
      instagram: "https://www.instagram.com/collectionofzaid_sa/",
      tiktok: "https://www.tiktok.com/@collectionofzaid_sa",
    },
    logo: ASSETS.coz,
    image: ASSETS.cozImg,
    bg: "#2C3E3A",
    accent: "#C4A27A",
    name: { ar: "مختارات زيد", en: "Collection of Zaid — COZ" },
    tag: { ar: "شوكولاتة، آيس كريم وحلويات", en: "Chocolate, Ice Cream & Sweets" },
    subtitle: { ar: "شوكولاتة، آيس كريم وحلويات", en: "Chocolate, Ice Cream & Sweets" },
    desc: {
      ar: "شوكولاتة وكيك وآيس كريم فاخر مع خدمات تموين المناسبات.",
      en: "Premium chocolates, cakes, ice cream & event catering.",
    },
  },
  {
    key: "goa",
    slug: "goa",
    status: "coming_soon",
    cardBadge: { ar: "مطبخ سحابي", en: "Cloud Kitchen" },
    social: {
      instagram: "https://www.instagram.com/goa_sa/",
      tiktok: "https://www.tiktok.com/@goa.ksa",
    },
    logo: ASSETS.goa,
    image: ASSETS.goaImg,
    bg: "#EDE4D3",
    accent: "#C15A3C",
    dark: true,
    name: { ar: "جوا", en: "GOA" },
    tag: { ar: "مطبخ سحابي", en: "Cloud Kitchen" },
    subtitle: { ar: "مطبخ سحابي", en: "Cloud Kitchen" },
    desc: {
      ar: "مطبخ هندي معاصر وقهوة مختصة بلمسة فنية.",
      en: "Contemporary Indian dining and specialty coffee.",
    },
  },
  {
    key: "zed",
    slug: "zed",
    status: "active",
    social: {
      instagram: "https://www.instagram.com/zed.ksa/",
      tiktok: "https://www.tiktok.com/@zed.ksa",
    },
    logo: ASSETS.zed,
    image: ASSETS.zedImg,
    bg: "#1C7A7C",
    accent: "#D6EEEE",
    name: { ar: "زد", en: "ZED" },
    tag: { ar: "Grab & Go", en: "Grab & Go" },
    subtitle: { ar: "طازج، صحي", en: "Ready. Set. Grab & Go" },
    desc: {
      ar: "وجبات طازجة وسناكات وقهوة مختصة بمفهوم عصري سريع.",
      en: "Fast casual fresh food, specialty coffee & snacks.",
    },
  },
  {
    key: "zed_meals",
    slug: "zed-meals",
    status: "active",
    social: {
      instagram: "https://www.instagram.com/zed_meals/",
      tiktok: "https://www.tiktok.com/@zed.meals",
    },
    logo: ASSETS.zedMeals,
    image: ASSETS.zedImg,
    bg: "#8A1A26",
    accent: "#E8DAB2",
    name: { ar: "زد ميلز", en: "ZED Meals" },
    tag: { ar: "اشتراكات وجبات صحية", en: "Healthy Meal Subscriptions" },
    subtitle: { ar: "اشتراكات وجبات صحية وزد جونيور", en: "Healthy Subscriptions & ZED Junior" },
    desc: {
      ar: "اشتراكات وجبات صحية ومتوازنة شهرياً وبرنامج زد جونيور لطلاب المدارس.",
      en: "Monthly healthy meal subscriptions and ZED Junior for school kids.",
    },
  },
  {
    key: "sahab",
    slug: "sahab",
    status: "coming_soon",
    cardBadge: { ar: "مطبخ سحابي", en: "Cloud Kitchen" },
    logo: ASSETS.sahab,
    image: ASSETS.sahabImg,
    bg: "#D4EDF0",
    accent: "#201A5B",
    dark: true,
    isNew: true,
    name: { ar: "سحاب برجر", en: "Sahab Burger" },
    tag: { ar: "مطبخ سحابي", en: "Cloud Kitchen" },
    subtitle: { ar: "مطبخ سحابي — جديد", en: "Cloud Kitchen — New" },
    desc: {
      ar: "علامة برجر طازج وعصري برؤية جودة عالية، وجه واعد في الوجبات السريعة الفاخرة.",
      en: "A fresh, modern gourmet burger brand — a promising face in premium fast food.",
    },
  },
];

export const CERT_FILES = [
  "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/sn622fxs_AL%20EZDHAR%20iso%209001%20-2026.pdf",
  "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/l5y6flwv_AL%20EZDHAR%20%20iso%2022000%20-%202026.pdf",
  "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/64l5m2ii_AL%20EZDHAR2026.pdf",
];

export const CLIENTS = [
  {
    name: "King Abdulaziz University",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/zzwo9f3j_images.png",
  },
  {
    name: "Saudi National Bank",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/97ab3ijf_SNB.jpg",
  },
  {
    name: "Dar Al-Hekma University",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/y9s80mvs_%D8%AC%D8%A7%D9%85%D8%B9%D8%A9%20%D8%AF%D8%A7%D8%B1%20%D8%A7%D9%84%D8%AD%D9%83%D9%85%D8%A9.webp",
  },
  {
    name: "Royal Commission for AlUla",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/wsi1ym2p_%D8%A7%D9%84%D9%87%D9%8A%D8%A6%D9%87%20%D8%A7%D9%84%D9%85%D9%84%D9%83%D9%8A%D8%A9%20%D9%84%D9%85%D8%AD%D8%A7%D9%81%D8%B8%D9%87%20%D8%A7%D9%84%D8%B9%D9%84%D8%A7.webp",
  },
  {
    name: "Bank AlJazira",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/u7x87h7v_%D8%A8%D9%86%D9%83%20%D8%A7%D9%84%D8%AC%D8%B2%D9%8A%D8%B1%D8%A9.jpg",
  },
  {
    name: "GACA — General Authority of Civil Aviation",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/poo5eln6_%D8%A7%D9%84%D9%87%D9%8A%D8%A6%D8%A9%20%D8%A7%D9%84%D8%B9%D8%A7%D9%85%D8%A9%20%D9%84%D9%84%D8%B7%D9%8A%D8%B1%D8%A7%D9%86%20%D8%A7%D9%84%D9%85%D8%AF%D9%86%D9%8A.png",
  },
  {
    name: "ROSHN",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/5uluo8u0_%D8%B1%D9%88%D8%B4%D9%86.png",
  },
  {
    name: "Saudi Binladin Group",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/03ru4mvc_%D9%85%D8%AC%D9%85%D9%88%D8%B9%D8%A9%20%D8%A8%D9%86%20%D9%84%D8%A7%D8%AF%D9%86%20%D8%A7%D9%84%D8%B3%D8%B9%D9%88%D8%AF%D9%8A%D8%A9.png",
  },
  {
    name: "Chalhoub Group",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/yd7rjzvt_chalhoub%20group.png",
  },
  {
    name: "Bayt Alebaa",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/shr1oi9c_%D8%A8%D9%8A%D8%AA%20%D8%A7%D9%84%D8%A7%D8%A8%D8%A7%D8%A1.jpg",
  },
  {
    name: "Almajal G4S",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/xmk1f9bv_almajal%20g4s.jpg",
  },
  {
    name: "Saudia Private Aviation",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/kgme5q2h_%D8%B7%D9%8A%D8%B1%D8%A7%D9%86%20%D8%A7%D9%84%D8%B3%D8%B9%D9%88%D8%AF%D9%8A%D8%A9%20%D8%A7%D9%84%D8%AE%D8%A7%D8%B5.jpg",
  },
  {
    name: "Dar Al Thikr Schools",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/m65k7od1_%D9%85%D8%AF%D8%A7%D8%B1%D8%B3%20%D8%AF%D8%A7%D8%B1%20%D8%A7%D9%84%D8%B0%D9%83%D8%B1.jpg",
  },
  {
    name: "AlAndalus Private Schools",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/tq5bq8yj_%D9%85%D8%AF%D8%A7%D8%B1%D8%B3%20%D8%A7%D9%84%D8%A3%D9%86%D8%AF%D9%84%D8%B3%20%D8%A7%D9%84%D8%A3%D9%87%D9%84%D9%8A%D8%A9.jpg",
  },
  {
    name: "Arty Cafe",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/6i5zta96_arty%20cafe.png",
  },
  {
    name: "Islamic Development Bank",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/yox57edz_%D8%A7%D9%84%D8%A8%D9%86%D9%83%20%D8%A7%D9%84%D8%A7%D8%B3%D9%84%D8%A7%D9%85%D9%8A%20%D9%84%D9%84%D8%AA%D9%86%D9%85%D9%8A%D8%A9.jpg",
  },
  {
    name: "Joffrey's Coffee & Tea",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/ku9qqj5o_%D8%AC%D9%88%D9%81%D8%B1%D9%8A%D8%B2.jpg",
  },
  {
    name: "KEY Car Rental",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/k0t5bfci_%D8%A7%D9%84%D9%85%D9%81%D8%AA%D8%A7%D8%AD.png",
  },
  {
    name: "Dr. Soliman Fakeeh Hospital",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/gtbxtg9s_%D9%81%D9%82%D9%8A%D8%A9.png",
  },
  {
    name: "Petromin",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/42eju8c8_%D8%A8%D8%AA%D8%B1%D9%88%D9%85%D9%8A%D9%86.png",
  },
  {
    name: "Nahdi",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/4vvo857f_%D8%A7%D9%84%D9%86%D9%87%D8%AF%D9%8A.webp",
  },
  {
    name: "Batterjee Medical College",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/rfrzspdw_%D9%83%D9%84%D9%8A%D8%A9%20%D8%A7%D9%84%D8%A8%D8%AA%D8%B1%D8%AC%D9%8A%20%D8%A7%D9%84%D8%B7%D8%A8%D9%8A%D8%A9.jpg",
  },
  {
    name: "University of Business and Technology",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/bwo3c1ry_%D8%AC%D8%A7%D9%85%D8%B9%D8%A9%20%D8%A7%D9%84%D8%A7%D8%B9%D9%85%D8%A7%D9%84%20%D9%88%D8%A7%D9%84%D8%AA%D9%83%D9%86%D9%88%D9%84%D9%88%D8%AC%D9%8A%D8%A7.jpg",
  },
  {
    name: "Waad Academy",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/lt1xhm00_%D9%85%D8%AF%D8%A7%D8%B1%D8%B3%20%D8%A3%D9%83%D8%A7%D8%AF%D9%8A%D9%85%D9%8A%D8%A9%20%D9%88%D8%B9%D8%AF.jpg",
  },
  {
    name: "My Clinic",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/dnambn7l_%D8%B9%D9%8A%D8%A7%D8%AF%D8%AA%D9%8A.png",
  },
  {
    name: "Effat University",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/p00qkq4j_%D8%AC%D8%A7%D9%85%D8%B9%D8%A9%20%D8%B9%D9%81%D8%AA.jpg",
  },
  {
    name: "Institute of Public Administration",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/26mqkad1_%D9%85%D8%B9%D9%87%D8%AF%20%D8%A7%D9%84%D8%A7%D8%AF%D8%A7%D8%B1%D9%87%20%D8%A7%D9%84%D8%B9%D8%A7%D9%85%D8%A9.jpg",
  },
  {
    name: "Basamh Group",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/bibx7f9c_%D8%A8%D8%A7%D8%B3%D9%85%D8%AD.png",
  },
  {
    name: "Saudi Commission for Health Specialties",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/kvk9zqw2_%D8%A7%D9%84%D9%87%D9%8A%D8%A6%D8%A9%20%D8%A7%D9%84%D8%B3%D8%B9%D9%88%D8%AF%D9%8A%D8%A9%20%D9%84%D9%84%D8%AA%D8%AE%D8%B5%D8%B5%D8%A7%D8%AA%20%D8%A7%D9%84%D8%B5%D8%AD%D9%8A%D8%A9.webp",
  },
  {
    name: "Al Balad Development Company",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/pz16kcdi_%D8%B4%D8%B1%D9%83%D8%A9%20%D8%AA%D8%B7%D9%88%D8%B1%20%D8%A7%D9%84%D8%A8%D9%84%D8%AF.jpg",
  },
  {
    name: "King Faisal Specialist Hospital & Research Centre",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/hqaewrkd_%D9%85%D8%B3%D8%AA%D8%B4%D9%81%D9%89%20%D8%A7%D9%84%D9%85%D9%84%D9%83%20%D9%81%D9%8A%D8%B5%D9%84%20%D8%A7%D9%84%D8%AA%D8%AE%D8%B5%D8%B5%D9%8A%20%D9%88%D9%85%D8%B1%D9%83%D8%B2%20%D8%A7%D9%84%D8%A3%D8%A8%D8%AD%D8%A7%D8%AB.jpeg",
  },
  {
    name: "Ministry of National Guard Health Affairs",
    logo: "https://customer-assets-jai6qajn.emergentagent.net/job_al-ezdhar-v2/artifacts/bfqkjq8w_%D9%88%D8%B2%D8%A7%D8%B1%D8%A9%20%D8%A7%D9%84%D8%AD%D8%B1%D8%B3%20%D8%A7%D9%84%D9%88%D8%B7%D9%86%D9%8A%20%D8%A7%D9%84%D8%B4%D8%A4%D9%88%D9%86%20%D8%A7%D9%84%D8%B5%D8%AD%D9%8A%D8%A9.jpg",
  },
];
